import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetClinicAppointmentStatsDTO } from "../../dtos/dashboard";
import dashboardService from "./dashboardService";

const initialState = {
  drawer: true,
  mobileDrawer: false,
  getClinicStatsPayload: null,
  getClinicAppointmentsStatsPayload: null,

  isGetClinicStatsError: false,
  isGetClinicAppointmentsStatsError: false,

  isSuccess: false,

  isGetClinicStatsLoading: false,
  isGetClinicAppointmentsStatsLoading: false,

  getClinicStatsMessage: "",
  getClinicAppointmentsStatsMessage: "",
};

export const getClinicStats = createAsyncThunk(
  "clinic/stats/get",
  async (clinicId: string, thunkAPI) => {
    try {
      return await dashboardService.getClinicStats(clinicId);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getClinicAppointmentsStats = createAsyncThunk(
  "clinic/appointments/stats/get",
  async (dto: GetClinicAppointmentStatsDTO, thunkAPI) => {
    try {
      return await dashboardService.getClinicAppointmentsStats(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    handleDrawerOpen: (state) => {
      state.drawer = true;
    },
    handleDrawerClose: (state) => {
      state.drawer = false;
    },
    handleMobileDrawerOpen: (state) => {
      state.mobileDrawer = true;
    },
    handleMobileDrawerClose: (state) => {
      state.mobileDrawer = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClinicStats.pending, (state) => {
        state.isGetClinicStatsLoading = true;
      })
      .addCase(getClinicStats.fulfilled, (state, action) => {
        state.isGetClinicStatsLoading = false;
        state.isSuccess = true;
        state.getClinicStatsMessage = "";
        state.isGetClinicStatsError = false;
        state.getClinicStatsPayload = action.payload;
      })
      .addCase(getClinicStats.rejected, (state, action: PayloadAction<any>) => {
        state.isGetClinicStatsLoading = false;
        state.isGetClinicStatsError = true;
        state.getClinicStatsMessage = action.payload;
      })
      .addCase(getClinicAppointmentsStats.pending, (state) => {
        state.isGetClinicAppointmentsStatsLoading = true;
      })
      .addCase(getClinicAppointmentsStats.fulfilled, (state, action) => {
        state.isGetClinicAppointmentsStatsLoading = false;
        state.isSuccess = true;
        state.getClinicAppointmentsStatsMessage = "";
        state.isGetClinicAppointmentsStatsError = false;
        state.getClinicAppointmentsStatsPayload = action.payload;
      })
      .addCase(
        getClinicAppointmentsStats.rejected,
        (state, action: PayloadAction<any>) => {
          state.isGetClinicAppointmentsStatsLoading = false;
          state.isGetClinicAppointmentsStatsError = true;
          state.getClinicAppointmentsStatsMessage = action.payload;
        }
      );
  },
});

export const {
  handleDrawerOpen,
  handleDrawerClose,
  handleMobileDrawerOpen,
  handleMobileDrawerClose,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
